// Dados compartilhados entre as versões "Upload CSV" e "Copia e Cola"
// do fluxo de cadastro de plano de taxas.

export interface PlanoTaxa {
  id: number;
  nome: string;
  tipoAntecipado: boolean;
  tipoFluxoTempo: boolean;
  qtdSellers: number;
  dataCriacao: string; // ISO yyyy-mm-dd
  isDefaultAntecipado?: boolean;
  isDefaultFluxoTempo?: boolean;
}

export interface SellerMock {
  id: string;
  nome: string;
  cnpj: string;
}

export const COMPANY_MOCK = {
  nome: 'BARTE BRASIL LTDA',
  id: '117',
  cnpj: '60.571.477/0001-59',
};

export const INITIAL_PLANOS: PlanoTaxa[] = [
  { id: 4, nome: 'Plano Go Live - 13 MCCs', tipoAntecipado: true, tipoFluxoTempo: true, qtdSellers: 52, isDefaultAntecipado: true, isDefaultFluxoTempo: true, dataCriacao: '2024-08-14' },
  { id: 120, nome: 'Plano Antecipado', tipoAntecipado: false, tipoFluxoTempo: false, qtdSellers: 1, dataCriacao: '2025-02-03' },
  { id: 121, nome: 'Plano Fluxo do Tempo', tipoAntecipado: false, tipoFluxoTempo: false, qtdSellers: 1, dataCriacao: '2025-02-03' },
  { id: 187, nome: 'Calculadora_v02 - Antecipado (2).csv', tipoAntecipado: false, tipoFluxoTempo: false, qtdSellers: 1, dataCriacao: '2025-09-22' },
  { id: 202, nome: 'Ajuste de Taxas', tipoAntecipado: false, tipoFluxoTempo: false, qtdSellers: 1, dataCriacao: '2026-01-10' },
  { id: 203, nome: 'Ajuste de Taxas - Plano Antecipado', tipoAntecipado: true, tipoFluxoTempo: false, qtdSellers: 1, dataCriacao: '2026-03-18' },
  { id: 204, nome: 'Ajuste de Taxas - Fluxo do Tempo', tipoAntecipado: false, tipoFluxoTempo: true, qtdSellers: 1, dataCriacao: '2026-04-25' },
];

export const ALL_SELLERS: SellerMock[] = [
  { id: 'SLR-00001', nome: 'Mercado Bom Preço LTDA', cnpj: '12.345.678/0001-91' },
  { id: 'SLR-00002', nome: 'Padaria Pão Quente ME', cnpj: '23.456.789/0001-02' },
  { id: 'SLR-00003', nome: 'Loja Central de Departamentos', cnpj: '34.567.890/0001-13' },
  { id: 'SLR-00004', nome: 'Tech Store Eletrônicos S.A.', cnpj: '45.678.901/0001-24' },
  { id: 'SLR-00005', nome: 'FitLife Academia Esportes', cnpj: '56.789.012/0001-35' },
  { id: 'SLR-00006', nome: 'Ótica Visão Clara LTDA', cnpj: '67.890.123/0001-46' },
  { id: 'SLR-00007', nome: 'Pet Shop Animal Love', cnpj: '78.901.234/0001-57' },
  { id: 'SLR-00008', nome: 'Barbearia Corte Certo', cnpj: '89.012.345/0001-68' },
];

export const INITIAL_SELLERS_BY_PLANO: Record<number, string[]> = {
  4: Array.from({ length: 52 }, (_, i) => `SLR-${String(i + 1).padStart(5, '0')}`),
  120: ['SLR-00053'],
  121: ['SLR-00054'],
  187: ['SLR-00055'],
  202: ['SLR-00056'],
  203: ['SLR-00057'],
  204: ['SLR-00058'],
};

export function formatBR(iso: string): string {
  const [y, m, d] = iso.split('-');
  return `${d}/${m}/${y}`;
}

export function todayISO(): string {
  const d = new Date();
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
}
